import Action from "../base/action";

class ExplodeScene extends Action {
    centerPoint = new THREE.Vector3();
    unit;

    constructor(props) {
        super(props);

        const {unit, centerPoint} = Object.assign({
            unit: 0,
            centerPoint: [0, 0, 0]
        }, props);

        this.unit = unit;
        this.centerPoint.set(...centerPoint);
    }

    async execute() {
        showModelLevelExplosion(this.unit, this.centerPoint);
    }
}

export default ExplodeScene;